import { useMemo } from 'react';

import { generateSearchPath } from '../../utils/search';

import { type BreadcrumbsProps } from './Breadcrumbs';
import { type UseCategoryBreadcrumbsCategoryFragment } from './__generated-gql-types__/useCategoryBreadcrumbs.generated';

interface UseCategoryBreadcrumbsProps {
  category: Possible<UseCategoryBreadcrumbsCategoryFragment>;
  productOffering?: BreadcrumbsProps['breadcrumbs'];
}
export const useCategoryBreadcrumbs = ({
  category,
  productOffering = [],
}: UseCategoryBreadcrumbsProps) => {
  const breadcrumbs: BreadcrumbsProps['breadcrumbs'] = useMemo(() => {
    if (category) {
      return [
        {
          label: category.name,
          url: generateSearchPath({
            goal: category.goal,
            categorySlug: category.slug,
            subCategorySlug: null,
          }),
        },
        ...productOffering,
      ];
    }
    return productOffering;
  }, [category, productOffering]);

  return breadcrumbs;
};
